<template>
  <div class="mypage">

    <!-- image -->
    <v-card
      flat
      max-width="500"
      class="mx-auto"
      >
      <v-card-actions>
        <v-btn icon color="indigo"><v-icon>mdi-chart-bubble</v-icon></v-btn>
        <v-btn text>TTM</v-btn>
        <v-spacer></v-spacer>
        <Signup v-if="!user" class="mx-2" />
        <Login v-if="!user" class="mx-2" />
        <v-btn v-if="user" text color="blue-grey" router :to="{ name: 'MyPage'}">
          <span class="mr-2">내 페이지 가기</span>
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-parallax v-if="!user" src="/cactus.png" height="770">
        <v-row>
          <v-col cols="12">
            <v-row
              align="center"
              justify="center"
              style="height: 736px;"
            >
              <v-col cols="12">
                <div class="display-1 text-center">Table Tennis Manager</div>
              </v-col>         
            </v-row>
          </v-col>
        </v-row>
      </v-parallax>      
    </v-card>

    <!-- contests -->
    <v-row dense>
      <v-col v-for="contest in contests" :key="contest.created" cols="12">
        <v-card v-if="contests && user" max-width="500" class="mx-auto">
          <v-img :src="contest.image" height="320px" class="align-end white--text">
            <v-card-title v-text="contest.title"></v-card-title>
          </v-img>

          <v-list>
            <v-subheader>소개</v-subheader>
            <v-divider inset></v-divider>
            <v-list-item>
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>주관</v-list-item-title>
                <v-list-item-subtitle>{{contest.groupName}} ({{contest.groupRegion}})</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-group</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>시간</v-list-item-title>
                <v-list-item-subtitle v-text="contest.time" class="purple--text"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-clock-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>장소</v-list-item-title>
                <v-list-item-subtitle v-text="contest.location"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-map-marker-radius</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>회비</v-list-item-title>
                <v-list-item-subtitle v-text="contest.fee"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-cash-100</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="purple" text @click="goToGroup(contest.groupId)">바로 가기</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="show = !show">
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>

          <v-expand-transition>
            <div v-show="show">
              <v-divider></v-divider>
              <v-card-text v-text="contest.greeting"></v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <!-- Contact us -->
    <v-card max-width="500" class="mx-auto" v-if="!user">
      <v-list>
        <v-subheader>Contact us</v-subheader>
        <v-divider inset></v-divider>
        <v-list-item>    
          <v-list-item-action></v-list-item-action>      
          <v-list-item-content>
            <v-list-item-subtitle>010-3251-6012</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon class="blue-grey--text">mdi-phone</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-action></v-list-item-action> 
          <v-list-item-content>
            <v-list-item-subtitle>경기도 성남시 분당구 운중동</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon class="blue-grey--text">mdi-map-marker</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-action></v-list-item-action>
          <v-list-item-content>
            <v-list-item-subtitle>cchonhee@gmail.com</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon class="blue-grey--text">mdi-email</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- footer -->
    <v-footer v-if="!user" class="mx-auto" max-width="500" color="blue-grey lighten-3">        
      <div class="white--text ml-4">
        Made with
        <v-icon class="red--text">mdi-heart</v-icon>
        by <a class="white--text">Joe</a>
      </div>
    </v-footer>
  </div>
</template>

<script>
import Signup from '@/components/Signup'
import Login from '@/components/Login'
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Home',
  components: { Signup, Login },
  data: () => ({
    user: null,
    show: false,
    contests: []
  }),
  created(){
    // get user
    this.user = firebase.auth().currentUser
    if(this.user){
      // get contests
      db.collection('contests').orderBy('created').onSnapshot(snapshot => {
        let changes = snapshot.docChanges();
          changes.forEach(change => {
            if(change.type == 'added'){
                this.contests.unshift({
                    ...change.doc.data(),
                    id: change.doc.id
                });
            } else if(change.type == 'removed'){
                this.contests = this.contests.filter(contest => {
                    return contest.id != change.doc.id;
                })
            } else if(change.type == 'modified'){
                // console.log(change)
            }
          })
      })
    }
  },
  methods: {
    goToGroup(id){
      if(this.user){
        this.$router.push({ name: "Games", params: { group_id: id}})
      }
    }
  }
  
};
</script>


 